module.exports = __webpack_public_path__ + "static/img/website.2bace0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/website.png
// module id = DI3i
// module chunks = 1